import { Progress } from '@/components/ui/progress';

interface UploadProgressProps {
  isUploading: boolean;
  progress: number;
}

export function UploadProgress({ isUploading, progress }: UploadProgressProps) {
  if (!isUploading) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-primary/20 bg-primary/10 p-3 shadow-sm">
      <div className="mb-2 flex items-center justify-between text-sm text-foreground">
        <span>Uploading...</span>
        <span>{progress}%</span>
      </div>
      <Progress value={progress} className="h-2" />
    </div>
  );
}
